export const LOAD_MORE = 'load-more';
export const LOADING = 'loading';
